"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as r, forwardRef as l } from "react";
import { useSvgIcon as i } from "../useSvgIcon.js";
const t = r(
  l((C, n) => {
    const e = i({
      ...C,
      ref: n
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e(),
        children: /* @__PURE__ */ o(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.9999 6C12.3133 6 13.6135 6.25857 14.8267 6.76112C15.4753 7.0298 16.0922 7.36533 16.6679 7.76136C15.3906 8.93093 14.4057 10.867 13.2914 14.0632C12.9886 13.7048 12.6001 13.4152 12.1482 13.228C11.0273 12.7636 9.73681 13.0203 8.879 13.8783C8.02118 14.7364 7.76451 16.0266 8.22869 17.1477C8.69282 18.2687 9.78687 18.9994 10.9999 18.9996C11.2468 18.9998 11.4922 18.9696 11.7307 18.9101L9.53397 25.8917C7.45504 25.5834 5.48009 24.622 3.92911 23.0708C1.06934 20.2109 0.21378 15.9098 1.7613 12.1731C3.3092 8.43639 6.95548 6 10.9999 6ZM20.1788 19.9688C24.1535 19.676 26.9101 17.2969 27.7796 13.5C27.7796 13.5 24.7806 14.2312 22.2398 13.5H22.2402C27.2647 12.5267 30.1601 9.70042 30.9999 6.00037H25.9784C18.6648 6.00037 17.0839 6.66419 14.0001 16.4648L11.0372 25.8814C10.7764 25.9219 10.5141 25.952 10.2507 25.9717C10.9701 26.0259 11.6973 26.0025 12.4196 25.8989C12.9077 25.829 13.3906 25.723 13.8643 25.5813C14.3566 25.434 14.8362 25.2492 15.2988 25.0287C17.519 23.9723 19.2328 22.1553 20.1788 19.9688Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
t.displayName = "IconOnlyfans";
export {
  t as IconOnlyfans
};
